const schuifpuiReparatie = {
  seo: {
    title: "Schuifpui Reparatie Eindhoven | 48u Service",
    description:
      "Schuifpui loopt stroef, hangt scheef of sluit niet meer ? Wij repareren alle schuifpuien in Eindhoven. 48u-service, vaste prijs vanaf €95, 10 jaar garantie.",
  },
  breadcrumb: {
    home: "Home",
    diensten: "Diensten",
    current: "Schuifpui reparatie",
  },
  hero: {
    pill: "DIENST — SCHUIFPUI REPARATIE",
    h1: "Schuifpui reparatie in Eindhoven",
    subhead:
      "Loopt uw schuifpui stroef, hangt hij scheef of sluit hij niet meer? Wij zijn dé specialist in schuifpui reparatie in Eindhoven. Van aluminium tot glazen schuifpui — wij herstellen alle merken en materialen vakkundig, met 48u-service en 10 jaar garantie.",
    usps: ["Vanaf €95", "Vaak in 1 bezoek", "Rollers en rails op voorraad"],
    ctaPhone: "040 798 7470",
    ctaOfferte: "Gratis offerte",
  },
  intro: {
    h2: "Schuifpui hapert? Wij lossen het op",
    p1:
      "Een schuifpui van 10 tot 15 jaar oud gaat vaak haperen. Versleten rollers, vervormde rails, een ontregeld slot of een mechanisme dat niet meer wil — wij kennen elk probleem en weten precies wat het kost om het op te lossen. Of uw schuifpui nu loopt stroef, hangt scheef of helemaal vastzit, onze monteur weet raad.",
    p2:
      "Vervanging van de hele pui is meestal niet nodig en bovendien duur (€3.000 tot €6.000). Met gerichte schuifpui reparatie en professioneel schuifpui afstellen loopt uw pui weer geruisloos en jaren mee, voor een fractie van die kostprijs. Wij voeren schuifpui rollers vervangen uit met originele onderdelen, direct ter plaatse.",
    p3:
      "Wij werken aan alle grote merken: Schüco, Reynaers, Aluplast en Kömmerling. Van kunststof tot aluminium en glazen schuifpui — onze monteurs hebben rollers en rails op voorraad in de bestelwagen, waardoor de meeste reparaties in één bezoek klaar zijn.",
    p4:
      "Heeft uw schuifpui enkel glas? Door te vervangen door HR++ isolatieglas kunt u in aanmerking komen voor de ISDE-subsidie 2026.",
    p4Link: "Meer over glas vervangen →",
  },
  materialen: {
    h2: "Voor welk type schuifpui?",
    rows: [
      {
        title: "Aluminium schuifpui",
        desc:
          "Grote glaspartijen, zware vleugels. Het gewicht zorgt ervoor dat rollers sneller slijten en rails vervormen. Wij vervangen rollers en stellen de rail opnieuw af voor een soepele loop.",
      },
      {
        title: "Kunststof schuifpui",
        desc:
          "Lichter dan aluminium maar gevoelig voor uitzetting in de zomer. Hangt scheef, sluit niet meer goed of beslag stuk? Bijna altijd herstelbaar zonder de pui te vervangen.",
      },
      {
        title: "Houten schuifpui",
        desc:
          "Karaktervol maar onderhoudsgevoelig. Wij herstellen mechanisme, vervangen rollers en stellen de rail af. LET OP: voor houtrotreparaties verwijzen wij door naar een gespecialiseerde timmerman.",
      },
    ],
  },
  problemen: {
    h2: "Veelvoorkomende schuifpui problemen",
    items: [
      { nr: "01", title: "Schuifpui loopt stroef of zwaar", desc: "Versleten rollers of vervuild spoor. Wij reinigen, stellen af of vervangen rollers voor soepele loop." },
      { nr: "02", title: "Schuifpui hangt scheef of zakt door", desc: "Hoogte afstellen of rollers vervangen. Voorkomt beschadiging rail en kozijn." },
      { nr: "03", title: "Rollers of wieltjes versleten", desc: "Originele rollers vervangen per set. Direct op voorraad voor gangbare merken." },
      { nr: "04", title: "Rails vervuild of beschadigd", desc: "Reinigen, herstellen of vervangen van het onderste spoor voor geruisloze loop." },
      { nr: "05", title: "Slot of grendel defect", desc: "Sluitmechanisme, cilinder of grendel vervangen. SKG-keurmerk beschikbaar." },
      { nr: "06", title: "Tocht langs de schuifpui", desc: "Afstelling en nieuwe tochtstrip. Bespaart direct op energiekosten." },
    ],
  },
  merken: {
    h2: "Schuifpui merken die wij repareren",
    p1:
      "Wij repareren schuifpuien van alle grote merken die in Nederland verkocht worden. Of u nu een Schüco, Reynaers, Aluplast, Kömmerling, Sunflex of Solarlux schuifpui heeft — onze monteurs kennen de specifieke mechanismen en hebben passende onderdelen op voorraad.",
    p2:
      "Schüco en Reynaers zijn veel gebruikt in nieuwbouw en renovatieprojecten in Eindhoven. Aluplast en Kömmerling zien wij regelmatig in jaren '90- en '00-woningen. Sunflex en Solarlux zijn premium merken met specifieke profielen — ook daar hebben wij ervaring mee. Twijfelt u over het merk? Geen probleem, onze monteur herkent het ter plaatse.",
  },
  werkwijze: {
    h2: "Hoe wij werken",
    steps: [
      { nr: "01", title: "Aanvraag", desc: "Bel of formulier" },
      { nr: "02", title: "Diagnose", desc: "Monteur komt gratis langs, eerlijke offerte" },
      { nr: "03", title: "Reparatie", desc: "Vakkundig, vaak in 1 bezoek" },
      { nr: "04", title: "Garantie", desc: "Ondertekende verklaring 10 jaar" },
    ],
  },
  prijzen: {
    h2: "Wat kost schuifpui reparatie?",
    rows: [
      { dienst: "Schuifpui afstellen", prijs: "Vanaf €95", tijd: "30-60 min" },
      { dienst: "Rollers vervangen", prijs: "€150-300", tijd: "1-2 u" },
      { dienst: "Rails reinigen / vervangen", prijs: "€120-250", tijd: "1-2 u" },
      { dienst: "Slot / grendel vervangen", prijs: "€85-175", tijd: "30-60 min" },
      { dienst: "Glas vervangen schuifpui", prijs: "Op aanvraag", tijd: "1-3 u" },
      { dienst: "Voorrijkosten binnen 15 km", prijs: "Gratis", tijd: "—" },
    ],
    note: "Excl. 21% BTW. Vaste prijsopgave vooraf, geen verrassingen.",
  },
  waarom: {
    h2: "Waarom kiezen voor Ramen Repair Eindhoven?",
    reasons: [
      { nr: "01", title: "Eigen monteurs uit Brabant", desc: "Lokale vakkennis" },
      { nr: "02", title: "Rollers en rails op voorraad", desc: "Alle merken direct beschikbaar" },
      { nr: "03", title: "Transparante prijzen vooraf", desc: "Geen verrassingen" },
      { nr: "04", title: "10 jaar schriftelijke garantie", desc: "Op werken en onderdelen" },
    ],
  },
  faq: {
    h2: "Veelgestelde vragen",
    items: [
      {
        q: "Hoe vaak moeten rollers van een schuifpui vervangen worden?",
        a:
          "Gemiddeld elke 10 tot 15 jaar, afhankelijk van gebruik, gewicht van de pui en onderhoud. Aluminium schuifpuien met grote glaspartijen verslijten sneller. Wij kunnen dit beoordelen tijdens de gratis diagnose.",
      },
      {
        q: "Mijn schuifpui hangt scheef. Is dat ernstig?",
        a:
          "Vaak is het een kwestie van hoogte afstellen of rollers vervangen. Als de schuifpui jaren scheef heeft gelopen, kan de rail beschadigd zijn. Wij inspecteren dit gratis en adviseren eerlijk.",
      },
      {
        q: "Kunnen jullie ook oude schuifpuien herstellen?",
        a:
          "Zeker, zolang het profiel niet vervormd is en originele onderdelen nog leverbaar zijn. Bij zeldzame merken zoeken wij gericht naar passende onderdelen of bieden wij een passend alternatief.",
      },
      {
        q: "Is mijn 20 jaar oude schuifpui nog wel te herstellen?",
        a:
          "Meestal wel. Alleen als het profiel zelf vervormd is of als onderdelen niet meer leverbaar zijn, adviseren wij vervanging. Maar in de praktijk herstellen wij zelfs 25 jaar oude schuifpuien regelmatig.",
      },
      {
        q: "Kan ik een smart-lock op mijn schuifpui laten plaatsen?",
        a:
          "Dat hangt af van het profiel en de dikte. Wij kunnen tijdens de diagnose beoordelen of een smart-lock passend is. Zo niet, dan adviseren wij een veilige SKV-gecertificeerde cilinder met sleutels.",
      },
      {
        q: "Hoe snel is een spoedreparatie mogelijk?",
        a:
          "Voor spoedreparaties, bijvoorbeeld na inbraak of als de schuifpui niet meer sluit, kunnen wij vaak binnen 2 uur ter plaatse zijn in Eindhoven. Bel direct: 040 798 7470.",
      },
      {
        q: "Kan een schuifpui die stroef loopt gerepareerd worden?",
        a:
          "Ja, in bijna alle gevallen. Een schuifpui die stroef loopt is meestal het gevolg van versleten rollers, een vervuild spoor of ontregelde afstelling. Wij vervangen rollers, reinigen rails en stellen alles opnieuw af zodat uw schuifpui weer soepel loopt.",
      },
      {
        q: "Wat kost het vervangen van schuifpui rollers?",
        a:
          "Het vervangen van schuifpui rollers kost gemiddeld €150 tot €300 per set, afhankelijk van het merk en het gewicht van de pui. Aluminium schuifpuien met grote glaspartijen hebben zwaardere rollers en liggen aan de bovenkant van dit tarief. Wij geven altijd een vaste prijsopgave vooraf.",
      },
      {
        q: "Hoe snel kunnen jullie langskomen voor een schuifpui?",
        a:
          "Voor reguliere schuifpui reparatie plannen wij meestal binnen 24 tot 48 uur een afspraak. Bij spoed, bijvoorbeeld als de schuifpui niet meer sluit of vastzit, streven wij ernaar om binnen 2 uur ter plaatse te zijn in Eindhoven en omgeving.",
      },
    ],
  },
  links: {
    h2: "Gerelateerde diensten",
    cards: [
      {
        title: "Kozijnreparatie",
        desc: "Sluitmechanisme, beslag, scharnieren en rubbers voor alle materialen.",
        href: "/kozijn-reparatie/",
      },
      {
        title: "Glas vervangen",
        desc: "Gebroken ruit of upgrade naar HR++ isolatieglas voor uw schuifpui.",
        href: "/glas-vervangen/",
      },
      {
        title: "Draaikiepraam reparatie",
        desc: "Scheef hangende ramen weer recht en soepel laten draaien en kiepen.",
        href: "/draaikiepraam-reparatie/",
      },
      {
        title: "Slot- en cilindervervanging",
        desc: "Nieuwe sloten en cilinders direct gemonteerd na inbraak of sleutelverlies.",
        href: "/slot-cilinder-vervangen/",
      },
    ],
  },
  ctaBanner: {
    h2: "Schuifpui kapot in Eindhoven?",
    cta: "040 798 7470",
  },
  offerte: {
    h2: "Vraag een gratis offerte aan",
    intro:
      "Vertel ons kort wat er aan de hand is — wij nemen binnen enkele uren contact met u op met een eerlijk advies en, indien gewenst, een vrijblijvende offerte.",
    steps: ["Probleem", "Materiaal", "Gegevens"],
    step1: {
      label: "Wat is het probleem?",
      options: [
        "Loopt stroef",
        "Hangt scheef",
        "Rollers maken lawaai",
        "Rail beschadigd",
        "Slot werkt niet",
        "Sluit niet meer goed",
        "Anders",
      ],
    },
    step2: {
      label: "Wat voor materiaal?",
      options: ["Aluminium", "PVC / kunststof", "Hout", "Weet niet"],
    },
    step3: {
      firstName: "Voornaam",
      lastName: "Achternaam",
      phone: "Telefoon",
      email: "E-mail",
      address: "Adres",
      message: "Bericht (optioneel)",
      messagePlaceholder: "Beschrijf uw schuifpuiprobleem...",
      back: "Terug",
      next: "Volgende stap",
      submit: "Offerte aanvragen",
    },
  },
};

export default schuifpuiReparatie;